import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    isLoading: state.pages.productList.isLoading,
    productsDataView: getProductListDataView(state),
});

const mapDispatchToProps = {
    addProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface ProductListSortSelectStyles {
    select?: SelectPresentationProps;
}

const styles: ProductListSortSelectStyles = {
    select: {
        labelProps: {
            css: css`
                width: unset;
                position: relative;
                z-index: 100;
                left: 70px;
                top: -18px;
                font-size: 12px;
                font-weight: 600;
                background: white;
                color: gray;
                height: fit-content;
                margin: 9px 15px 0px 0px;
                padding: 0px;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 310px;
                select[class^="SelectStyle"] {
                    background: white;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                            padding-top: 20px;
                            justify-content: flex-start;
                        `,
                        css`
                            width: 100%;
                            padding-top: 20px;
                            justify-content: flex-start;
                        `,
                        null,
                        null,
                        null,
                    ])}
            `,
        },
    },
};

export const sortSelectStyles = styles;

const ProductListSortSelectCustom: FC<Props> = ({ addProductFilters, productsDataView }) => {
    if (!productsDataView.value) {
        return null;
    }

    const sortOptions = productsDataView.pagination!.sortOptions;

    const onChangeSortHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        addProductFilters({ sort: event.currentTarget.value });
    };

    const count = productsDataView.pagination!.totalItemCount;

    if (count !== 0) {
        return (
            <Select
                {...styles.select}
                label={translate("Sort by:")}
                value={productsDataView.pagination!.sortType}
                labelPosition="left"
                onChange={onChangeSortHandler}
                data-test-selector="productListSortSelect"
            >
                {sortOptions.map(sortOption => (
                    <option key={sortOption.sortType} value={sortOption.sortType}>
                        {sortOption.displayName}
                    </option>
                ))}
            </Select>
        );
    }
    return <></>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListSortSelectCustom),
    definition: {
        group: "Product List",
        displayName: "Sort Select Custom",
        allowedContexts: [ProductListPageContext],
    },
};

export default widgetModule;
